const isValidTrackingValue = (value) =>
	typeof value === 'string' &&
	value.length > 0 &&
	!['undefined', 'null'].includes(value);

/**
 * Click counting uses per-send `mid`.
 * `sk` is stored via setupUtms for order_source attribution.
 */
export const resolveMailClickPayloadFromSearch = (searchParams) => {
	const params =
		searchParams instanceof URLSearchParams
			? searchParams
			: new URLSearchParams(searchParams || '');

	const mid = params.get('mid');

	if (!isValidTrackingValue(mid)) {
		return null;
	}

	return { mid };
};
